import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global unhandled promise rejection handler
window.addEventListener("unhandledrejection", function(event) {
  console.error("Unhandled Promise Rejection:", event.reason);
  // Prevent the default browser behavior (console error)
  event.preventDefault();
});

// Global error handler for uncaught errors
window.addEventListener("error", function(event) {
  console.error("Uncaught Error:", event.error || event.message);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
